import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const fromEnv = (key, fallback = "") => {
  const value = process.env[key];
  return typeof value === "string" && value.trim() ? value.trim() : fallback;
};

const firebaseConfig = {
  apiKey: fromEnv("REACT_APP_FIREBASE_API_KEY", "AIzaSyBMplWh9RGQn9T42c39E6TwiBL7dHp-_6w"),
  authDomain: fromEnv("REACT_APP_FIREBASE_AUTH_DOMAIN", "ezer-4caeb.firebaseapp.com"),
  projectId: fromEnv("REACT_APP_FIREBASE_PROJECT_ID", "ezer-4caeb"),
  storageBucket: fromEnv("REACT_APP_FIREBASE_STORAGE_BUCKET", "ezer-4caeb.firebasestorage.app"),
  messagingSenderId: fromEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID", "943846443634"),
  appId: fromEnv("REACT_APP_FIREBASE_APP_ID", "1:943846443634:web:a632624708e2d6ee3c10eb"),
  measurementId: fromEnv("REACT_APP_FIREBASE_MEASUREMENT_ID", "G-7EDBRQ3P2T"),
};

if (!firebaseConfig.apiKey || !firebaseConfig.projectId || !firebaseConfig.appId) {
  throw new Error("Firebase configuration is missing. Set REACT_APP_FIREBASE_* environment variables.");
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functionsApi = getFunctions(app, fromEnv("REACT_APP_FIREBASE_FUNCTIONS_REGION", "us-central1"));
export default app;
